import * as betgalaxy from './ToggleAccountView.styles.betgalaxy';
import * as betprofessor from './ToggleAccountView.styles.betprofessor';
import * as betroyale from './ToggleAccountView.styles.betroyale';
import * as fiestabet from './ToggleAccountView.styles.fiestabet';
import * as goldenrush from './ToggleAccountView.styles.goldenrush';
import * as juicybet from './ToggleAccountView.styles.juicybet';
import * as puntcity from './ToggleAccountView.styles.puntcity';
import * as puntgenie from './ToggleAccountView.styles.puntgenie';
import * as questbet from './ToggleAccountView.styles.questbet';
import * as sterlingparker from './ToggleAccountView.styles.sterlingparker';
import * as vikingbet from './ToggleAccountView.styles.vikingbet';
import * as volcanobet from './ToggleAccountView.styles.volcanobet';
import * as wellbet from './ToggleAccountView.styles.wellbet';
import * as junglebet from './ToggleAccountView.styles.junglebet';
import * as oldgill from './ToggleAccountView.styles.oldgill';
import * as sugarcastle from './ToggleAccountView.styles.sugarcastle';
import * as buffalobet from './ToggleAccountView.styles.buffalobet';
import * as titanbet from './ToggleAccountView.styles.titanbet';
import * as slambet from './ToggleAccountView.styles.slambet';
import * as gigabet from './ToggleAccountView.styles.gigabet';
import * as betstride from './ToggleAccountView.styles.betstride';
import * as templebet from './ToggleAccountView.styles.templebet';
import * as goldenbet888 from './ToggleAccountView.styles.goldenbet888';
import * as hyperbet from './ToggleAccountView.styles.hyperbet';
import * as bet777 from './ToggleAccountView.styles.bet777';
import * as chromabet from './ToggleAccountView.styles.chromabet';
import * as bet575 from './ToggleAccountView.styles.bet575';
import * as betblast from './ToggleAccountView.styles.betblast';
import * as pyramidbet from './ToggleAccountView.styles.pyramidbet';
import * as magnumbet from './ToggleAccountView.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
